<template>
  <div id="recommand-app-modal" class="modal fade" :class="{ 'is-open': open }">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="col-12 pl-0">
            <h3 class="modal-title">照護資訊連結</h3>
          </div>
        </div>
        <div class="modal-body" style="min-height: 50px">
          <table style="display: grid">
            <tr class="pl-0" style="width:100%;">
              <td class="col-12">
                <span style="margin-left: 10px" class="modal-text"
                  >業務同仁提供保戶照護資訊</span
                >
              </td>
            </tr>
            <tr
              class="pl-0"
              style="width:100%;"
              v-for="item in data"
              :key="`solicitude-tr-${item.option}`"
            >
              <td style="width:33%;">
                <ul style="list-style-type: disc">
                  <li class="modal-text fw-bold">
                    {{ item.option_name }}
                  </li>
                </ul>
              </td>
              <td style="width:33%;">
                <a
                  class="modal-text link text-underline"
                  target="_blank"
                  :href="item.memo"
                  @click="$emit('insertLog', item.option)"
                  >網站超連結</a
                >
              </td>
              <td style="width:33%;">
                <input
                  type="text"
                  style="position: absolute; left: -10000px; top: -10000px"
                  ref="copyEldSolicitudeUrl"
                />
                <button
                  type="button"
                  style="font-size: 20px; float: right"
                  class="btn btn-default btn-sm"
                  @click="copy(item.memo, item.option)"
                >
                  複製連結
                </button>
              </td>
              <td>
                <i
                  class="icon-line"
                  style="cursor: pointer"
                  @click="encodeLink(item.memo, item.option)"
                ></i>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EldSolicitudeFormModal",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    encodeLink(link, option) {
      this.$emit("insertLog", option);
      let str = encodeURI(link);
      let url = `http://line.naver.jp/R/msg/text/?${str}`;
      window.open(url);
    },
    //複製連結
    copy(url, option) {
      const copyText = this.$refs.copyEldSolicitudeUrl[0];
      copyText.value = url;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      if (document.execCommand("cut")) {
        this.$emit("insertLog", option);
        this.$toast.info({ title: "連結已複製" });
      } else {
        console.error("複製失敗");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-dialog {
  width: 700px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -200px 0 0 -350px;
}

.modal-text {
  font-size: 20px;
  font-weight: 400;
}

.fw-bold {
  font-weight: bold;
}
</style>
